import { Nav } from "react-bootstrap";

interface INavPageProps extends React.HTMLProps<HTMLElement>{
  defaultActiveKey: string;
}
interface INavPageItemProps extends React.HTMLProps<HTMLElement>{
  to?: string;
  eventKey: string;
  disabled: boolean;
}

function ItemNavPage({ children, to, eventKey, disabled = false, ...props}:INavPageItemProps){
  return (
    <Nav.Item>
      <Nav.Link href={to} eventKey={eventKey} disabled={disabled}>{children}</Nav.Link>
    </Nav.Item>
  );
}

function NavPage({children, defaultActiveKey}:INavPageProps){
  return (
    <Nav variant="pills" defaultActiveKey={defaultActiveKey}>
      {children}
    </Nav>
  );
}

export default Object.assign(NavPage,{
  Item: ItemNavPage
});

